import React, { useEffect, useRef, useState } from 'react';

import useIntersectionObserver from '../../../utils/hooks/useIntersectionObserver';

interface props {
  imgSrc?: string;
  imgAlt?: string;
  className?: string;
}

const LazyLoad: React.FC<props> = ({ className, children, imgSrc = null, imgAlt = '' }) => {
  const elementRef = React.createRef<HTMLDivElement>();
  const imgRef = React.createRef<HTMLImageElement>();

  const [isImageLoaded, setIsImgLoaded] = useState(false);
  const { isIntersecting } = useIntersectionObserver(elementRef, true);
  let dataUrl = useRef<string>('');

  let image = new Image();
  let canvas = document.createElement('canvas');

  useEffect(() => {
    if (isIntersecting && imgSrc !== null && !isImageLoaded) {
      image.src = imgSrc;
      image.onload = () => {
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;

        let ctx = canvas.getContext('2d');
        ctx?.drawImage(image, 0, 0);
        dataUrl.current = canvas.toDataURL('image/png');

        setIsImgLoaded(true);
      };
    }
  }, [isIntersecting]);

  return (
    <div
      className={`lazy-image ${isImageLoaded && 'lazy-image--loaded'} ${className}`}
      ref={elementRef}
    >
      {isIntersecting && imgSrc
        ? isImageLoaded && <img ref={imgRef} src={dataUrl.current} alt={imgAlt} />
        : children}
    </div>
  );
};

export default LazyLoad;
